<script>
import flatPickr from 'vue-flatpickr-component';
import "flatpickr/dist/themes/material_blue.css";

export default {
	components: { flatPickr },
	props : {
		value : {
			type : String,
			required : true,
		},
	},
	data() {
		return {
			config : {
				enableTime : true
			}
		}
	},
	methods : {
		onChange(selectedDates, dateStr, instance) {
			this.$emit('input', dateStr);
		}
	}
}
</script>

<template>
	<flat-pickr
		:value="value"
		:config="config"
		class="form-control"
		@on-change="onChange">
	</flat-pickr>
</template>
